export default {
    setConfig(state, cfg) {
        const cfgKeys = Object.keys(cfg);
        for (let cfgKey of cfgKeys) {
            if (Object.prototype.hasOwnProperty.call(state, cfgKey))
                state[cfgKey] = cfg[cfgKey];
        }
    }
}
